import { Star } from "lucide-react";
import { Reveal } from "./Reveal";

const REVIEWS = [
  { name: "Sarah M.", suburb: "Brighton", text: "The S-Fold sheers completely changed our living room. Measured on Tuesday, installed three weeks later — flawless finish.", stars: 5 },
  { name: "Daniel & Priya K.", suburb: "Hawthorn", text: "Motorized blockouts synced with Google Home in every bedroom. The kids' rooms are pitch black now. Worth every dollar.", stars: 5 },
  { name: "Grace L.", suburb: "Mornington", text: "Honest advice, no upsell. They talked us out of a more expensive fabric because it wouldn't suit our light. That's trust.", stars: 5 },
  { name: "Tom R.", suburb: "Docklands", text: "Plantation shutters across the whole apartment. Installers were tidy, quick and left everything child-safety certified.", stars: 5 },
];

const Stars = ({ n }) => (
  <span className="flex gap-0.5" aria-label={`${n} out of 5 stars`}>
    {Array.from({ length: 5 }).map((_, i) => <Star key={i} size={14} className={i < n ? "fill-brass text-brass" : "text-line"} />)}
  </span>
);

const GoogleMark = () => (
  <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.7-6.7C35.6 2.6 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.8 6C12.3 13.2 17.7 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17.5z" />
    <path fill="#FBBC05" d="M10.4 28.8A14.6 14.6 0 0 1 9.5 24c0-1.7.3-3.3.9-4.8l-7.8-6A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.8l7.8-6z" />
    <path fill="#34A853" d="M24 48c6.2 0 11.6-2 15.4-5.6l-7.5-5.8c-2.1 1.4-4.8 2.3-7.9 2.3-6.3 0-11.7-3.7-13.6-9.2l-7.8 6C6.5 42.6 14.6 48 24 48z" />
  </svg>
);

export const Reviews = () => (
  <section id="reviews" className="py-20 lg:py-28 bg-linen border-b border-line" data-testid="reviews-section">
    <div className="container-x">
      <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
        <div>
          <p className="eyebrow mb-4">Customer Reviews</p>
          <h2 className="h-display text-3xl sm:text-4xl text-ink">Trusted in homes across Melbourne.</h2>
        </div>
        <div className="flex items-center gap-4 bg-white border border-line px-5 py-3 self-start sm:self-auto" data-testid="google-rating-badge">
          <GoogleMark />
          <div>
            <div className="flex items-center gap-2"><span className="font-serif text-2xl text-ink leading-none">4.9</span><Stars n={5} /></div>
            <p className="text-[11px] text-stone mt-1">Based on 127 Google reviews</p>
          </div>
        </div>
      </Reveal>

      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-line border border-line" data-testid="reviews-grid">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={i * 0.1} className="bg-linen p-7 lg:p-8 flex flex-col group hover:bg-white transition-colors duration-500" data-testid={`review-card-${i + 1}`}>
            <Stars n={r.stars} />
            <p className="mt-5 font-serif text-lg lg:text-xl text-ink leading-snug flex-1">“{r.text}”</p>
            <div className="mt-6 flex items-center justify-between">
              <div>
                <p className="text-sm font-semibold text-ink-2">{r.name}</p>
                <p className="text-xs text-stone">{r.suburb}</p>
              </div>
              <GoogleMark />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
